export default __webpack_public_path__ + "static/form-grouping-do-a018f1eaf6f440698f1e961b2ca96f08eb52cc0235bf7cf16d38f14697927192.png";